// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.3_@rspack+core@1.7.6_webpack@5.99.9/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.3_@rspack+core@1.7.6_webpack@5.99.9/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  align-items: start;
  justify-content: space-between;
  margin-bottom: var(--space-05);
}

.label-container, .label-aside {
  line-height: var(--label-line-height);
  padding-block: var(--label-padding);
}

.label-aside {
  /* Align with a label.d-form-check, which adds padding. */
  margin-top: calc(var(--has-form-check-label, 0) * var(--form-check-padding-block));
}

.label-buttons {
  /*
   * I do not understand why this is needed,
   * but without it, the buttons are vertically off.
   */
  margin-bottom: var(--space-05);
}

/*
 * margin and padding moved to .header and
 * .label-container respectively when slotted.
 */

::slotted(label[slot='label']) {
  --label-padding: 0;

  margin: 0 !important; /** !important because otherwise an unwanted line break might occur. */
}

:host(.is-invalid) .control-container:not(.has-control) {
  background-color: var(--color-error-02-transp);
  box-shadow: var(--color-error-02-transp) 0 0 0 var(--space-05);
  display: inline-block;
}

/* Validation hint and error message */

.invalid-feedback,
.validation-hint {
  line-height: var(--label-line-height);
  margin: var(--space-1) 0 0;
}

.validation-hint {
  color: var(--muted-color);
}

/*
 * Validation hint and error message are not shown if the form group is disabled.
 * And they're not shown at the same time.
 */

.invalid-feedback:empty,
.validation-hint:empty,
:host(:is(.is-disabled, :not(.is-invalid))) .invalid-feedback,
:host(:is(.is-disabled, .is-invalid)) .validation-hint {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./packages/ui/src/form-group/form-group.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;EACE,yDAAyD;EACzD,kFAAkF;AACpF;;AAEA;EACE;;;IAGE;EACF,8BAA8B;AAChC;;AAEA;;;EAGE;;AACF;EACE,kBAAkB;;EAElB,oBAAoB,EAAE,sEAAsE;AAC9F;;AAEA;EACE,8CAA8C;EAC9C,8DAA8D;EAC9D,qBAAqB;AACvB;;AAEA,sCAAsC;;AAEtC;;EAEE,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE;;AACF;;;;EAIE,aAAa;AACf","sourcesContent":[".header {\n  align-items: start;\n  justify-content: space-between;\n  margin-bottom: var(--space-05);\n}\n\n.label-container, .label-aside {\n  line-height: var(--label-line-height);\n  padding-block: var(--label-padding);\n}\n\n.label-aside {\n  /* Align with a label.d-form-check, which adds padding. */\n  margin-top: calc(var(--has-form-check-label, 0) * var(--form-check-padding-block));\n}\n\n.label-buttons {\n  /*\n   * I do not understand why this is needed,\n   * but without it, the buttons are vertically off.\n   */\n  margin-bottom: var(--space-05);\n}\n\n/*\n * margin and padding moved to .header and\n * .label-container respectively when slotted.\n */\n::slotted(label[slot='label']) {\n  --label-padding: 0;\n\n  margin: 0 !important; /** !important because otherwise an unwanted line break might occur. */\n}\n\n:host(.is-invalid) .control-container:not(.has-control) {\n  background-color: var(--color-error-02-transp);\n  box-shadow: var(--color-error-02-transp) 0 0 0 var(--space-05);\n  display: inline-block;\n}\n\n/* Validation hint and error message */\n\n.invalid-feedback,\n.validation-hint {\n  line-height: var(--label-line-height);\n  margin: var(--space-1) 0 0;\n}\n\n.validation-hint {\n  color: var(--muted-color);\n}\n\n/*\n * Validation hint and error message are not shown if the form group is disabled.\n * And they're not shown at the same time.\n */\n.invalid-feedback:empty,\n.validation-hint:empty,\n:host(:is(.is-disabled, :not(.is-invalid))) .invalid-feedback,\n:host(:is(.is-disabled, .is-invalid)) .validation-hint {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
var ___CSS_LOADER_STYLE_SHEET___ = new CSSStyleSheet();
___CSS_LOADER_STYLE_SHEET___.replaceSync(___CSS_LOADER_EXPORT___.toString());
export default ___CSS_LOADER_STYLE_SHEET___;
